(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7437],{

/***/ 6986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ships",
      function () {
        return __webpack_require__(91616);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ResultPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _components_ShipsPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21831);
/* harmony import */ var _components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24277);
/* harmony import */ var _components_Collapsed__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63145);
/* harmony import */ var _components_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82372);
/* harmony import */ var _styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71706);
/* harmony import */ var _styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27101);












var __N_SSP = true;
function ResultPage(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var pageRoute = [
        {
            title: "Поиск теплоходов",
            link: "/ships"
        }
    ];
    var items = [
        {
            title: "Бескрайние просторы: открываем мир речных круизов",
            body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        component: "p",
                        pabottomGap: "12",
                        children: "Круизы с каждым годом пользуются все большим спросом. Очевидное преимущество – посещение разнообразных локаций на пути следования. Путешественники могут увидеть старинные города, памятники архитектуры, музеи, галереи и театры. И все это без многочисленных перелетов и переездов."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        component: "p",
                        pabottomGap: "12",
                        children: "Вот лишь несколько причин отправиться в путешествие на круизном лайнере:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "можно увидеть много стран за одну поездку;"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "путешествие проходит в комфорте;"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "на борту доступна масса развлечений на любой вкус."
                            })
                        ]
                    })
                ]
            })
        },
        {
            title: "Какие бывают классы теплоходов?",
            body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        component: "p",
                        pabottomGap: "12",
                        children: "Чтобы вам было удобнее, мы разделили все теплоходы на пять классов. Какое бы судно вы ни выбрали, исходя из его категории, рейтинга и других характеристик, оно может подарить вам незабываемый отдых."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        children: "Премиум."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        component: "p",
                                        children: "На таких больших теплоходах предусмотрены не просто каюты, а полноценные номера с панорамными окнами и всем необходимым для прекрасного путешествия. Вам каждый день будут открываться новые захватывающие виды. Также на борту есть бассейн, рестораны, бары, спортивные залы и массажные салоны, бильярд и многое другое для комфортного отдыха класса премиум. Вы уже отдыхали на четырехпалубном судне? Сейчас самое время!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        children: "Люкс."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        component: "p",
                                        children: [
                                            " ",
                                            "Путешественников ждет прекрасный отдых на комфортабельных теплоходах, живописные берега, дизайнерские интерьеры и увлекательные экскурсии. Что же еще? Авторская кухня, большой выбор напитков, разнообразные развлечения на борту и хороший сервис."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        children: "Комфорт."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        component: "p",
                                        children: "Прекрасное соотношение цены и качества тура. Широкая география маршрутов, различная продолжительность круизов, экскурсионная и развлекательная программы на борту – продумано всё! Туристы отдыхают душой и телом и получают хороший сервис."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        children: "Стандарт."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        component: "p",
                                        children: "Предусмотрены современные интерьеры и каюты со всем необходимым. Экскурсии и формат питания туристы могут подобрать индивидуально. Если многолюдным и активным путешествиям вы предпочитаете более спокойные, этот отдых для вас."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        children: "Эконом."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqList),
                                        component: "p",
                                        children: "Туры обычно проходят на небольших уютных теплоходах, где вы можете ощутить атмосферу путешествия. Все речные суда оснащены современным навигационным оборудованием и прошли реновацию с обновлением интерьеров."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        component: "p",
                        topGap: "12",
                        children: "Посмотреть список судов, фото теплоходов, почитать описание речных теплоходов, а также купить путевку онлайн на теплоходы из Москвы и не только вы можете на нашем сайте. Вас ждет удивительный отдых вместе с \xabКруиз.онлайн\xbb!"
                    })
                ]
            })
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_10__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            user: user
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                user: user
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: "Каталог речных теплоходов России на 2025 год – описание, классы теплоходов, расписание круизов",
                    description: "Речные круизные теплоходы для путешествий по России от эконом до премиум класса. Новые, большие и современные теплоходы для речных круизов из Москвы по рекам страны. Выбирайте комфортное судно для путешествия, ознакомьтесь с ценами и расписанием круизов на 2024 и 2025 год и оформляйте заявку онлайн.",
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    popularPopdirs: popularPopdirs,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container--block",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_7__/* .BreadCrumbs */ .b, {
                                    routeCrumbs: pageRoute
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ShipsPage__WEBPACK_IMPORTED_MODULE_6__/* .ShipsPage */ .G, {
                                isMobile: isMobile
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                className: (_styles_shipsPage_module_sass__WEBPACK_IMPORTED_MODULE_11___default().faqSection),
                                itemScope: true,
                                itemType: "https://schema.org/FAQPage",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Collapsed__WEBPACK_IMPORTED_MODULE_8__/* .Collapsed */ .H, {
                                    items: items,
                                    shorter: true,
                                    isCruis: true
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 71706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"shipsPage_faqSection__qoNwk","faqList":"shipsPage_faqList__GeiSL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3108,9179,9774,2888,179], function() { return __webpack_exec__(6986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);